/** Shared border radius for branch analysis surfaces (reduced roundness). */
export const BRANCH_ANALYSIS_RADIUS = 1;
